function init() {
  $('.layout-contact-forms').each(function() {
    var $layout = $(this);
    var $navTabs = $layout.find('.nav-tabs');
    var $navSelector = $layout.find('select');

    $navSelector.on('change', function() {
      $navTabs.find('a').eq($(this).val()).tab('show');
    });
  });
}

export default init;



// WEBPACK FOOTER //
// ./scripts/flexible-content/contactForms.js